import React, { useState, useEffect } from 'react';
import { ButtonToggle, ButtonToggleGroup } from 'carbon-react/esm/components/button-toggle';
import FilterStatusProps from '../types/filterstatus.types';
import { STATUS_CONFIG } from '../constants/dsntable.constants';
import { blurOnClick } from '../../../utils/blurOnClick';

const FilterStatusButtonBar = ({ onStatusChange, selectedStatus }: FilterStatusProps) => {
  const [value, setValue] = useState(selectedStatus || '');

  useEffect(() => {
    setValue(selectedStatus ?? '');
  }, [selectedStatus]);

  const handleChange = (event: React.MouseEvent<HTMLButtonElement>, selectedValue?: string) => {
    const newValue = selectedValue === value ? '' : selectedValue || '';
    if (!newValue) {
      blurOnClick(event);
    }
    setValue(newValue);
    onStatusChange(newValue);
  };

  return (
    <ButtonToggleGroup id="status-toggle" value={value} onChange={handleChange} allowDeselect>
      {Object.entries(STATUS_CONFIG).map(([statusKey, statusItem]) => (
        <ButtonToggle key={statusKey} value={statusKey} buttonIcon={statusItem.icon}>
          {statusItem.label}
        </ButtonToggle>
      ))}
    </ButtonToggleGroup>
  );
};

export default FilterStatusButtonBar;
